module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Pizza-9748129e870c236c43d8bd87aac197c1108039310947bcf288487fa77aa71f02.svg";